<div *ngIf="showLoadingIndicator || ajaxLoading" class="spinnerLayer">
  <div  class="spinner"></div>
</div>

<router-outlet></router-outlet>